// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings {
  display: flex;
  width: 100%;
}

.Setting_User {
  width: 100%;
  display: grid;
  gap: 5%;
}

.Setting_User_Header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-height: 40px;
}

.Setting_User_Header span {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #3f3325;
}

.Multiple_Images span{
  font-size: 14px;
}

.Multiple_Images_Dropdown{
  display: flex;
  gap: 0.5vw;
  align-items: center;
  margin-right: 1vw;

}
.Edit_Multiple_Btn {
  background: #ffffff;
  width: fit-content;
  border: 1px solid #e8dfd5;
  font-size: 2.5vh;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 7px 12px;
  gap: 8px;
  height: 40px;
}

.Submit_Multiple_Btn button{
  padding: 1vh 1vw;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #E67817;
  border-radius: 8px;
  border-color: transparent;
  font-size: 0.75rem;
  color: #FFFF;
  transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}

.custom-popup {
  width: 800px !important;
  height: 65vh !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.Images_Filter_Container {
  display: flex;
}
.Filter_Species_Display {
  margin-left: 6px;
}

.Filter_Upload_Type{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.Filter_Species_Display span {
  font-size: 1vw;
}

.Radio_Buttons_Container{
  display: flex;
  gap: 1vw;
}

.Radio_Buttons_Single{
  cursor: pointer;
}

.role_filter {
  position: relative;
  display: inline-block;
}

.role_filter.disabled {
  opacity: 0.5;
  cursor: not-allowed;
 
}

.role_filter select {
  padding: 8px 12px;
  font-size: 16px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
}

.role_filter select:disabled {
  background-color:  white;
  color: #aaa;
  cursor: not-allowed;
}

.role_filter option {
  padding: 8px 12px;
  font-size: 16px;
}
.custom-select-placeholder .ant-select-selection-placeholder {
  font-size: 16px;
}

.filter_count {
  position: absolute;
  top: 0;
  right: 0;
  margin: 1px;
  width: 0.8rem;
  height: 0.8rem;
  background-color: #38514c;
  border-radius: 50%;
}

.Setting_Table {
  width: 100%;
  height: 70vh;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);
  border-radius: 8px;
  padding: 4%;
}

.map_Setting_Table {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);
  border-radius: 8px;
  padding: 4%;
  height: 80vh;
  overflow: auto;
}

.map_Setting_Table::-webkit-scrollbar {
  visibility: hidden;
  display: none;
}

.settings_Child {
  padding: 2%;
  width: 100%;
  overflow-y: auto;
}

.Setting_User_Header input {
  background: #ffffff;
  border: 1px solid #e8dfd5;
  border-radius: 8px;
  width: 100%;
  padding: 20px;
  padding-left: 40px;
  height: 40px;
}

.Setting_User_Header input::placeholder {
  color: #9a938a;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.Setting_User_Header input:focus-visible {
  outline: none;
}

.Setting_filter {
  background: #ffffff;
  width: 65px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px solid #e8dfd5;
  border-radius: 6px;
}

.Setting_filter > span {
  color: #594f42;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.Setting_Upload_Button > button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(72, 136, 123, 0.1);
  border-radius: 8px;
  padding: 7px 12px;
  border: none;
  cursor: pointer;
  height: 40px;
  color: #38514c;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.Setting_Add_Button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e67817;
  color: #ffffff;
  border-radius: 8px;
  padding: 7px 12px;
  border: none;
  cursor: pointer;
  height: 40px;
  font-weight: 500;
  gap: 10px;
  font-size: 14px;
  line-height: 20px;
}

.Setting_Confirm_Button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 255, 255);
  color: #000000;
  border-radius: 8px;
  padding: 7px 12px;
  border: none;
  cursor: pointer;
  height: 40px;
  width: 100px;
  font-weight: 600;
  gap: 10px;
  font-size: 13px;
  line-height: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Adding shadow */
}

.Setting_Update_Button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 255, 255);
  color: #000000;
  border-radius: 8px;
  padding: 7px 12px;
  border: none;
  cursor: pointer;
  height: 40px;
  width: 120px;
  font-weight: 600;
  margin-left: -5px;
  font-size: 13px;
  line-height: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Adding shadow */
}

.Setting_Select_Button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e67817;
  color: #ffffff;
  border-radius: 8px;
  padding: 7px 12px;
  border: none;
  cursor: pointer;
  height: 30px;
  font-weight: 500;
  gap: 10px;
  font-size: 10px;
  line-height: 20px;
  opacity: 0.5;
}

.Setting_Select_Button.active {
  opacity: 1;
  font-weight: bold;
}

.large-image {
  width: 300px; /* Adjust width as needed */
  height: 300px; /* Adjust height as needed */
}
.Setting_Add_Button > span {
  color: #ffffff;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.Setting_Table_Header > span {
  color: #594f42;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}

.Setting_Table_Header {
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: center;
  border-bottom: 1px solid rgb(232, 223, 213, 0.5);
}

.Alert_Header {
  height: 20px;
}

.Setting_Table_Layout {
  margin-top: 10px;
  overflow: auto;
  height: 50vh;
}

.species_list {
  max-height: 60vh;
  overflow: auto;
}
.species_list::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.species_search_wrapper {
  display: flex;
  align-items: center;
  padding: 5px 15px;
}

.species_search_wrapper img {
  margin-right: 10px;
}

.species_search_wrapper input {
  margin-left: 8px;
  font-size: 0.87rem;
  background-color: none;
  width: 10vw;
  border: none;
  outline: none;
}

.Setting_Table_Layout::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 10px;
}

.Setting_Table_Layout table {
  border-collapse: collapse;
  width: 100%;
}

.Setting_Table_Layout tr {
  border-bottom: 1px solid rgb(232, 223, 213, 0.5);
  height: 48px;
}

.Setting_Table_Layout .heading_row {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #ffffff;
}

.Setting_Table_Layout .heading_row span {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #9a938a;
}

.Setting_Table_Layout .main_row span {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #3f3325;
}

.main_row td:nth-child(n + 3) span {
  color: #594f42;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}

.main_row:hover .row_icon {
  visibility: visible;
}
.row_icon {
  visibility: hidden;
  width: 30px;
  height: 48px;
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 5px;
}

.row_icon .row_delete {
  cursor: pointer;
}

.row_icon .row_edit {
  cursor: pointer;
}

.role_search {
  position: relative;
  display: grid;
  width: 276px;
  align-items: center;
}

.role_search > img {
  position: absolute;
  left: 12px;
  cursor: pointer;
}

.role_ClearAll button {
  background: #e67817;
  color: white;
  font-weight: 400;
  width: fit-content;
  border: 1px solid #e8dfd5;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 7px 12px;
  gap: 8px;
  height: 40px;
}

.role_filter {
  background: #ffffff;
  width: fit-content;
  border: 1px solid #e8dfd5;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 7px 12px;
  gap: 8px;
  height: 40px;
}

.filterListData > div > input {
  outline: none;
  border: none;
  border-radius: 8px;
  width: 100%;
  padding-left: 40px;
  height: 40px;
}

.role_filter:focus-visible {
  outline: none;
}

.role_Calander {
  background: #ffffff;
  border: 1px solid #e8dfd5;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 7px 12px;
  cursor: pointer;
  height: 40px;
}

.role_filter_span {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #594f42;
}

.setting_map_content {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  overflow-y: auto;
  padding: 10px;
  gap: 20px;
}

.setting_map {
  width: 100%;
  /* background: #FCF9F7; */
  border-radius: 8px;
  cursor: pointer;
}

.Setting_Map_Block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Setting_Map_Block span {
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #594f42;
}

.map_edit_heading {
  display: flex;
  gap: 5px;
  align-items: center;
}

.map_edit_heading > img {
  cursor: pointer;
}

.map_edit_heading > span {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #3f3325;
}

.map_edit_image {
  display: flex;
  justify-content: center;
  margin: auto;
  height: 192px;
  width: 202px;
}

.rowImgCombine {
  display: flex;
  align-items: center;
  gap: 4px;
}

.row_Img {
  border-radius: 4px !important;
  overflow: hidden;
  width: 32px;
  height: 32px;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.row_Img > img {
  width: 100%;
  height: 100%;
}

.setting_map > img {
  width: 168px;
  height: 182px;
}

.alertbody > div {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #594f42;
}

.alertwrapper {
  top: 6rem !important;
  height: fit-content;
  min-height: 0px !important;
  background: none !important;
  box-shadow: none !important;
}

.alertdangerwrapper {
  top: 6rem !important;
  height: fit-content;
  min-height: 0px !important;
  background: none !important;
  box-shadow: none !important;
}

.alertwrapper > div {
  background: #f2fcfb !important;
  padding: 0 !important;
  border: 1px solid #e8f0ee;
  min-height: auto;
  box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);
  border-radius: 8px;
}

.alertdangerwrapper > div {
  background: #fff5f4 !important;
  padding: 0 !important;
  border: 1px solid #e8f0ee;
  min-height: auto;
  box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);
  border-radius: 8px;
}

.deselect {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  color: #38514c;
}

.warning {
  font-weight: 400;
  font-size: 10px;
  line-height: 20px;
  color: red;
}

.small_loader {
  display: flex;
  animation: spin 2s linear infinite;
}

.small_loader_parent {
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
}

.toggle_disabled {
  cursor: no-drop !important;
}

.alerts-select-placeholder .ant-select-selection-overflow {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap;
  overflow: auto;
  align-items: center;
  max-height: 38px;
}
.ant-select-multiple .ant-select-selection-placeholder {
  font-size: 1rem;
}

.alerts-select-placeholder .ant-select-arrow {
  svg {
    transform: scale(0.5);
  }
}

.alerts-select-placeholder .ant-select-selection-item {
  width: fit-content;
  height: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.alerts-select-placeholder .ant-select-selection-item-content {
  font-size: 0.75rem;
}

.alerts-select-placeholder .ant-select-selection-item-remove {
  display: none;
}
.alerts-select-placeholder .ant-select-arrow {
  right: 0;
}

.tiger-image-grid {
  display: flex;
  flex-direction: column;
  width: 14vw; 
  height: 16vw;
}

.tiger-image-item1,
.tiger-image-container-item2 {
  width: 100%; 
  height: 50%; 
  display: flex;
}

.tiger-image-item2 {
  width: 50%;
}

.tiger-image-item1 {
  padding: 0.1vw 0.05vw;
}
.tiger-image-item2 {
  margin: 0vw 0.05vw;
}
.tiger-image-item1 img {
  border-top-left-radius: 5%;
  border-top-right-radius: 5%;
}

.tiger-image-item2.leftimg img {
  border-bottom-right-radius: 5%;
}

.tiger-image-item2.rightimg img {
  border-bottom-left-radius: 5%; 
}

.tiger-image-item1 img,
.tiger-image-item2 img {
  width: 100%;
  height: 100%; 
  object-fit: cover; 
}

.tiger_individual_container {
  display: flex;
  flex-direction: row;
}

.tiger_individual_container img {
  max-width: 10vw;
}

.tiger-category-heading {
  font-size: "1rem" !important;
  font-weight: bold;
  cursor: "pointer";
}

.tigertview_back_button{
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e67817;
  color: #ffffff;
  border-radius: 8px;
  padding: 2px 5px;
  border: none;
  cursor: pointer;
  height: 40px;
  font-weight: 500;
  font-size: 12px;
  width: 70px;
}


.duration-dropdown .ant-select-selector {
  align-items: center;          
}

.duration-dropdown .ant-select-selection-item {
  font-size: 15px !important;
  line-height: 22px !important;
}
`, "",{"version":3,"sources":["webpack://./src/CSS/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,iBAAiB;;AAEnB;AACA;EACE,mBAAmB;EAEnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;AAC9E;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wCAAwC,EAAE,kBAAkB;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wCAAwC,EAAE,kBAAkB;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,2BAA2B;EACzC,aAAa,EAAE,4BAA4B;AAC7C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB;2CACyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB;2CACyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EAEb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":[".settings {\n  display: flex;\n  width: 100%;\n}\n\n.Setting_User {\n  width: 100%;\n  display: grid;\n  gap: 5%;\n}\n\n.Setting_User_Header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-height: 40px;\n}\n\n.Setting_User_Header span {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #3f3325;\n}\n\n.Multiple_Images span{\n  font-size: 14px;\n}\n\n.Multiple_Images_Dropdown{\n  display: flex;\n  gap: 0.5vw;\n  align-items: center;\n  margin-right: 1vw;\n\n}\n.Edit_Multiple_Btn {\n  background: #ffffff;\n  width: -moz-fit-content;\n  width: fit-content;\n  border: 1px solid #e8dfd5;\n  font-size: 2.5vh;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 7px 12px;\n  gap: 8px;\n  height: 40px;\n}\n\n.Submit_Multiple_Btn button{\n  padding: 1vh 1vw;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: #E67817;\n  border-radius: 8px;\n  border-color: transparent;\n  font-size: 0.75rem;\n  color: #FFFF;\n  transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n\n.custom-popup {\n  width: 800px !important;\n  height: 65vh !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.Images_Filter_Container {\n  display: flex;\n}\n.Filter_Species_Display {\n  margin-left: 6px;\n}\n\n.Filter_Upload_Type{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.Filter_Species_Display span {\n  font-size: 1vw;\n}\n\n.Radio_Buttons_Container{\n  display: flex;\n  gap: 1vw;\n}\n\n.Radio_Buttons_Single{\n  cursor: pointer;\n}\n\n.role_filter {\n  position: relative;\n  display: inline-block;\n}\n\n.role_filter.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n \n}\n\n.role_filter select {\n  padding: 8px 12px;\n  font-size: 16px;\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n}\n\n.role_filter select:disabled {\n  background-color:  white;\n  color: #aaa;\n  cursor: not-allowed;\n}\n\n.role_filter option {\n  padding: 8px 12px;\n  font-size: 16px;\n}\n.custom-select-placeholder .ant-select-selection-placeholder {\n  font-size: 16px;\n}\n\n.filter_count {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 1px;\n  width: 0.8rem;\n  height: 0.8rem;\n  background-color: #38514c;\n  border-radius: 50%;\n}\n\n.Setting_Table {\n  width: 100%;\n  height: 70vh;\n  background: #ffffff;\n  box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);\n  border-radius: 8px;\n  padding: 4%;\n}\n\n.map_Setting_Table {\n  width: 100%;\n  background: #ffffff;\n  box-shadow: 0px 4px 16px rgba(172, 124, 98, 0.05);\n  border-radius: 8px;\n  padding: 4%;\n  height: 80vh;\n  overflow: auto;\n}\n\n.map_Setting_Table::-webkit-scrollbar {\n  visibility: hidden;\n  display: none;\n}\n\n.settings_Child {\n  padding: 2%;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.Setting_User_Header input {\n  background: #ffffff;\n  border: 1px solid #e8dfd5;\n  border-radius: 8px;\n  width: 100%;\n  padding: 20px;\n  padding-left: 40px;\n  height: 40px;\n}\n\n.Setting_User_Header input::placeholder {\n  color: #9a938a;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Setting_User_Header input:focus-visible {\n  outline: none;\n}\n\n.Setting_filter {\n  background: #ffffff;\n  width: 65px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border: 1px solid #e8dfd5;\n  border-radius: 6px;\n}\n\n.Setting_filter > span {\n  color: #594f42;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Setting_Upload_Button > button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(72, 136, 123, 0.1);\n  border-radius: 8px;\n  padding: 7px 12px;\n  border: none;\n  cursor: pointer;\n  height: 40px;\n  color: #38514c;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Setting_Add_Button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e67817;\n  color: #ffffff;\n  border-radius: 8px;\n  padding: 7px 12px;\n  border: none;\n  cursor: pointer;\n  height: 40px;\n  font-weight: 500;\n  gap: 10px;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Setting_Confirm_Button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgb(255, 255, 255);\n  color: #000000;\n  border-radius: 8px;\n  padding: 7px 12px;\n  border: none;\n  cursor: pointer;\n  height: 40px;\n  width: 100px;\n  font-weight: 600;\n  gap: 10px;\n  font-size: 13px;\n  line-height: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Adding shadow */\n}\n\n.Setting_Update_Button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgb(255, 255, 255);\n  color: #000000;\n  border-radius: 8px;\n  padding: 7px 12px;\n  border: none;\n  cursor: pointer;\n  height: 40px;\n  width: 120px;\n  font-weight: 600;\n  margin-left: -5px;\n  font-size: 13px;\n  line-height: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Adding shadow */\n}\n\n.Setting_Select_Button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e67817;\n  color: #ffffff;\n  border-radius: 8px;\n  padding: 7px 12px;\n  border: none;\n  cursor: pointer;\n  height: 30px;\n  font-weight: 500;\n  gap: 10px;\n  font-size: 10px;\n  line-height: 20px;\n  opacity: 0.5;\n}\n\n.Setting_Select_Button.active {\n  opacity: 1;\n  font-weight: bold;\n}\n\n.large-image {\n  width: 300px; /* Adjust width as needed */\n  height: 300px; /* Adjust height as needed */\n}\n.Setting_Add_Button > span {\n  color: #ffffff;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Setting_Table_Header > span {\n  color: #594f42;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Setting_Table_Header {\n  display: flex;\n  justify-content: space-between;\n  height: 50px;\n  align-items: center;\n  border-bottom: 1px solid rgb(232, 223, 213, 0.5);\n}\n\n.Alert_Header {\n  height: 20px;\n}\n\n.Setting_Table_Layout {\n  margin-top: 10px;\n  overflow: auto;\n  height: 50vh;\n}\n\n.species_list {\n  max-height: 60vh;\n  overflow: auto;\n}\n.species_list::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.species_search_wrapper {\n  display: flex;\n  align-items: center;\n  padding: 5px 15px;\n}\n\n.species_search_wrapper img {\n  margin-right: 10px;\n}\n\n.species_search_wrapper input {\n  margin-left: 8px;\n  font-size: 0.87rem;\n  background-color: none;\n  width: 10vw;\n  border: none;\n  outline: none;\n}\n\n.Setting_Table_Layout::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 10px;\n}\n\n.Setting_Table_Layout table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.Setting_Table_Layout tr {\n  border-bottom: 1px solid rgb(232, 223, 213, 0.5);\n  height: 48px;\n}\n\n.Setting_Table_Layout .heading_row {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #ffffff;\n}\n\n.Setting_Table_Layout .heading_row span {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #9a938a;\n}\n\n.Setting_Table_Layout .main_row span {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #3f3325;\n}\n\n.main_row td:nth-child(n + 3) span {\n  color: #594f42;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.main_row:hover .row_icon {\n  visibility: visible;\n}\n.row_icon {\n  visibility: hidden;\n  width: 30px;\n  height: 48px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  gap: 5px;\n}\n\n.row_icon .row_delete {\n  cursor: pointer;\n}\n\n.row_icon .row_edit {\n  cursor: pointer;\n}\n\n.role_search {\n  position: relative;\n  display: grid;\n  width: 276px;\n  align-items: center;\n}\n\n.role_search > img {\n  position: absolute;\n  left: 12px;\n  cursor: pointer;\n}\n\n.role_ClearAll button {\n  background: #e67817;\n  color: white;\n  font-weight: 400;\n  width: fit-content;\n  border: 1px solid #e8dfd5;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 7px 12px;\n  gap: 8px;\n  height: 40px;\n}\n\n.role_filter {\n  background: #ffffff;\n  width: fit-content;\n  border: 1px solid #e8dfd5;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 7px 12px;\n  gap: 8px;\n  height: 40px;\n}\n\n.filterListData > div > input {\n  outline: none;\n  border: none;\n  border-radius: 8px;\n  width: 100%;\n  padding-left: 40px;\n  height: 40px;\n}\n\n.role_filter:focus-visible {\n  outline: none;\n}\n\n.role_Calander {\n  background: #ffffff;\n  border: 1px solid #e8dfd5;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 7px 12px;\n  cursor: pointer;\n  height: 40px;\n}\n\n.role_filter_span {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #594f42;\n}\n\n.setting_map_content {\n  display: flex;\n  flex-wrap: wrap;\n  height: 100%;\n  overflow-y: auto;\n  padding: 10px;\n  gap: 20px;\n}\n\n.setting_map {\n  width: 100%;\n  /* background: #FCF9F7; */\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.Setting_Map_Block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.Setting_Map_Block span {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #594f42;\n}\n\n.map_edit_heading {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n\n.map_edit_heading > img {\n  cursor: pointer;\n}\n\n.map_edit_heading > span {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #3f3325;\n}\n\n.map_edit_image {\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  height: 192px;\n  width: 202px;\n}\n\n.rowImgCombine {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.row_Img {\n  border-radius: 4px !important;\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.row_Img > img {\n  width: 100%;\n  height: 100%;\n}\n\n.setting_map > img {\n  width: 168px;\n  height: 182px;\n}\n\n.alertbody > div {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  color: #594f42;\n}\n\n.alertwrapper {\n  top: 6rem !important;\n  height: fit-content;\n  min-height: 0px !important;\n  background: none !important;\n  box-shadow: none !important;\n}\n\n.alertdangerwrapper {\n  top: 6rem !important;\n  height: fit-content;\n  min-height: 0px !important;\n  background: none !important;\n  box-shadow: none !important;\n}\n\n.alertwrapper > div {\n  background: #f2fcfb !important;\n  padding: 0 !important;\n  border: 1px solid #e8f0ee;\n  min-height: auto;\n  box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08),\n    0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n  border-radius: 8px;\n}\n\n.alertdangerwrapper > div {\n  background: #fff5f4 !important;\n  padding: 0 !important;\n  border: 1px solid #e8f0ee;\n  min-height: auto;\n  box-shadow: 0px 20px 24px -4px rgba(148, 93, 63, 0.08),\n    0px 8px 8px -4px rgba(16, 24, 40, 0.03);\n  border-radius: 8px;\n}\n\n.deselect {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  cursor: pointer;\n  color: #38514c;\n}\n\n.warning {\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 20px;\n  color: red;\n}\n\n.small_loader {\n  display: flex;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n.small_loader_parent {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  align-items: center;\n}\n\n.toggle_disabled {\n  cursor: no-drop !important;\n}\n\n.alerts-select-placeholder .ant-select-selection-overflow {\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: wrap;\n  overflow: auto;\n  align-items: center;\n  max-height: 38px;\n}\n.ant-select-multiple .ant-select-selection-placeholder {\n  font-size: 1rem;\n}\n\n.alerts-select-placeholder .ant-select-arrow {\n  svg {\n    transform: scale(0.5);\n  }\n}\n\n.alerts-select-placeholder .ant-select-selection-item {\n  width: fit-content;\n  height: 4vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.alerts-select-placeholder .ant-select-selection-item-content {\n  font-size: 0.75rem;\n}\n\n.alerts-select-placeholder .ant-select-selection-item-remove {\n  display: none;\n}\n.alerts-select-placeholder .ant-select-arrow {\n  right: 0;\n}\n\n.tiger-image-grid {\n  display: flex;\n  flex-direction: column;\n  width: 14vw; \n  height: 16vw;\n}\n\n.tiger-image-item1,\n.tiger-image-container-item2 {\n  width: 100%; \n  height: 50%; \n  display: flex;\n}\n\n.tiger-image-item2 {\n  width: 50%;\n}\n\n.tiger-image-item1 {\n  padding: 0.1vw 0.05vw;\n}\n.tiger-image-item2 {\n  margin: 0vw 0.05vw;\n}\n.tiger-image-item1 img {\n  border-top-left-radius: 5%;\n  border-top-right-radius: 5%;\n}\n\n.tiger-image-item2.leftimg img {\n  border-bottom-right-radius: 5%;\n}\n\n.tiger-image-item2.rightimg img {\n  border-bottom-left-radius: 5%; \n}\n\n.tiger-image-item1 img,\n.tiger-image-item2 img {\n  width: 100%;\n  height: 100%; \n  object-fit: cover; \n}\n\n.tiger_individual_container {\n  display: flex;\n  flex-direction: row;\n}\n\n.tiger_individual_container img {\n  max-width: 10vw;\n}\n\n.tiger-category-heading {\n  font-size: \"1rem\" !important;\n  font-weight: bold;\n  cursor: \"pointer\";\n}\n\n.tigertview_back_button{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e67817;\n  color: #ffffff;\n  border-radius: 8px;\n  padding: 2px 5px;\n  border: none;\n  cursor: pointer;\n  height: 40px;\n  font-weight: 500;\n  font-size: 12px;\n  width: 70px;\n}\n\n\n.duration-dropdown .ant-select-selector {\n  align-items: center;          \n}\n\n.duration-dropdown .ant-select-selection-item {\n  font-size: 15px !important;\n  line-height: 22px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
